import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import {Card, CardBody} from 'components/card';
import Section from 'helpers/Section';
import LazyImage from 'helpers/LazyImage';
import {formatPrice} from 'lib/helpers/globalize-helper';
import Brussels from 'assets/images/destinations/Europe/Brussels.jpg';
import Rome from 'assets/images/destinations/Europe/Rome.jpg';
import Berlin from 'assets/images/destinations/Europe/Berlin.jpg';
import London from 'assets/images/destinations/Europe/London.jpg';
import Milan from 'assets/images/destinations/Europe/Milan.jpg';
import Krakow from 'assets/images/destinations/Europe/Krakow.jpg';

const settings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  arrows: true,
  responsive: [{
    breakpoint: 800,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
};
const items = [
  {
    img: London,
    price: 37
  },
  {
    img: Brussels,
    price: 33
  },
  {
    img: Milan,
    price: 47
  },
  {
    img: Krakow,
    price: 33
  },
  {
    img: Rome,
    price: 54
  },
  {
    img: Berlin,
    price: 34
  }
];

const itemWithCity = (cities) => items.map((item, i) => ({
  ...item,
  title: cities[i]
}));

const slides = (data, fromPrice) => data.map(({img, title, price}, i) =>
  (
    <a href="#" key={i} className="d-block p-2">
      <Card shadow>
        <LazyImage imgClass="card-img-top" src={img} alt={title} title={title} />
        <CardBody className="d-flex">
          <span className="font-bold">{title}</span>
          <span className="ml-auto">{fromPrice} <b>{formatPrice(price)}</b></span>
        </CardBody>
      </Card>
    </a>
  )
);

const HotelsDeals = ({cities, translations: {bookHotels, fromPrice}}) => (
  <Section
    sectionClass="py-8 text-center bg-light"
    renderTitle={() => (
      <h1 className="display-2 text-center font-light mb-4">{bookHotels}</h1>
    )}
  >
    <Slider {...settings}>
      {slides(itemWithCity(cities), fromPrice)}
    </Slider>
  </Section>
);

HotelsDeals.propTypes = {
  cities: PropTypes.array.isRequired,
  translations: PropTypes.shape({
    fromPrice: PropTypes.string.isRequired,
    bookHotels: PropTypes.string.isRequired
  }).isRequired
};

export default HotelsDeals;
